export default {
  form: {
    font_family: {
      label: 'Font family',
    },
    header: {
      label: 'Header',
      placeholder: 'Header',
    },
    sub_header: {
      label: 'Sub Header',
      placeholder: 'Sub header',
    },
    footer: {
      label: 'Footer text',
      placeholder: 'Enter footer text',
    },
    url_type: {
      label: 'URL',
      placeholder: 'Select URL',
    },
    url: {
      placeholder: 'www.example.com',
    },
    primary_color: {
      label: 'Primary color',
    },
    background_color: {
      label: 'Background color',
    },
    cover_image: {
      label: 'Cover image',
    },
    logo: {
      label: 'Logo',
    },
    logo_zoom: {
      label: 'Logo zoom',
    },
  },
  toasts: {
    failed_to_load_data: 'Failed to load door sticker',
  },
};
